/* global $ */
import React, { Component } from 'react';
/*import GoogleMapReact from 'google-map-react';*/
import { Map, Marker, Popup, TileLayer } from 'react-leaflet'
import CheckMark from './../images/google-maps-marker.png';
import { config } from '../config.js';

const CheckMarkComponent = () => <div><img src={CheckMark} style={{height: '40px'}} /></div>;

export class MapComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            markers: [],
        };
        this.previousRequest = undefined;
    }



    componentDidMount() {
        this.loadNetworkDevicesData();
    }

    loadNetworkDevicesData() {
        var token = this.props.accessToken;
        if (token == null) {
           token = sessionStorage.getItem('token') || 0;
        }
        var self = this;
        this.previousRequest = $.ajax({
            url: config.networkDeviceServiceUrl + '/network-devices',
            method: 'GET',
            dataType: 'json',
            crossDomain: true,
            cache: false,
            beforeSend: function(request) {
                request.setRequestHeader("Authorization", "Bearer " + token);
            },
            success: function(data) {
                if (data.items.length) {
                    this.setState({
                        markers: [{lat: data.items[0].latitude, lng: data.items[0].longitude}],
                    });
                }
            }.bind(this),
            error: function(xhr, status, err) {
                console.error(this.props.url, status, err.toString());
                if (xhr.status === 401) {
                    this.props.showLogin();
                }
            }.bind(this)
        });
    }

    checkCenter() {
        var self = this;
        if (this.state.markers.length > 0) {
            return [self.state.markers[0].lat,  self.state.markers[0].lng]
        }else {

        }

        return [ 51.5074, 0.1278];
    }

    render() {
        var centerPos = this.checkCenter();
        return (
            <div>
            {(this.state.markers.length > 0 && (this.state.markers[0].lat !== 0 || this.state.markers[0].lng !==0))?


                <Map center={centerPos} zoom={13} style={{height: '300px'}}>
                    <TileLayer
                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                        attribution="&copy; <a href=&quot;http://osm.org/copyright&quot;>OpenStreetMap</a> contributors"
                    />
                    <Marker position={centerPos}>
                    </Marker>
                </Map>:
                ''}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Map.jsx